import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProjectService } from 'src/app/modules/shared/services/project.service';

@Component({
  selector: 'ui-post',
  templateUrl: './ui-post.component.html',
  styleUrls: ['./ui-post.component.scss']
})
export class UiPostComponent implements OnInit, OnDestroy {
  private _destroy$: Subject<any> = new Subject();
  @Input() component;
  @Input() parent;

  private readonly catalogLinkType: string = "CATALOG_LINK";
  public catalogLink = null;

  constructor(
    private _projectService: ProjectService
  ) { }

  // this.catalogLink = this.catalogLink.concat("64400d335323543161619a25"); // PROD TEST
  ngOnInit(): void {
    if (this.component.componentConfig.subType == this.catalogLinkType) {
      this._projectService.networkProfile$.pipe(takeUntil(this._destroy$)).subscribe(profile => {
        this.catalogLink = `https://website.offertetouroperator.com/landing/cataloghi/player/`;
        this.catalogLink = this.catalogLink.concat(this.component.content.ctaTarget);
        this.catalogLink = this.catalogLink.concat(`?code=${profile.id_network_agency}&network=${profile.id_network}`);
      })
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete();
  }

}
